import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useFindAgentContext} from '../contexts/FindAgentContext';
import DataItemSelectAsync from '../../_common/components/DataItemSelectAsync';
import {transfersSelectStyles} from '../../_common/styles/reactSelectStyles';

export function FindAgent() {
  const [agentID, setAgentID] = useState(0);
  const history = useHistory();
  const {findAgents, formik} = useFindAgentContext();
  const goToAgentTransfersPage = () => history.push(`/transfersByAgent/${agentID}`);

  useEffect(() => {
    if (formik.values.agentID) goToAgentTransfersPage();
  }, [formik.values.agentID]);

  return (
    <DataItemSelectAsync
      fieldId={'agentID'}
      containerStyle={'mb-5 w-400px'}
      customStyles={transfersSelectStyles}
      loadOptions={findAgents}
      getOptionLabel={e => [e.agentID, e.fullName, e.idNumber].filter(Boolean).join(' - ')}
      getOptionValue={e => e.agentID}
      onChange={(value) => Boolean(value?.agentID) ? setAgentID(value.agentID) : setAgentID(0)}
    />
  );
}
